// extracted by mini-css-extract-plugin
module.exports = {"legal-wrapper":"LegalWrapper_legal-wrapper__1oq6Z"};